export enum ViewTypes {
  WithWorkouts = 'withWorkouts',
  ZeroState = 'zeroState',
}
